import React from "react";
import { Link } from "react-router-dom";

const AccountDropdown = ({
    is_user_active,
    open,
    setOpen,
    isMobile,
    accountRef,
    iconSize = "15px",
    dropdownTopClass = "top-2",
    dropdownAlignClass = "left-[0]",
    className = ""
}) => {
    return (
        <div 
            ref={accountRef}
            className={`relative gi-acc-drop flex items-center justify-center ${className}`}
            onMouseEnter={() => !isMobile && setOpen(true)}
            onMouseLeave={() => !isMobile && setOpen(false)}
        >
            <div
                className="gi-header-btn gi-header-user dropdown-toggle gi-user-toggle  
        relative flex text-black w-[auto] items-center whitespace-nowrap gap-1"
                title="Account"
                onClick={() => setOpen(prev => !prev)}
            >
                <div className="header-icon relative flex">
                    <i className={`fi-rr-user text-[#fff] text-[${iconSize}] leading-[17px]`}></i>
                </div>
                <span
                    className="gi-btn-title  hidden md:inline  text-[13px] leading-[1] text-[#fff] capitalize font-medium">Account</span>
            </div>

            {/* DROPDOWN */}
            {is_user_active ? (
                <ul
                    className={`gi-dropdown-menu min-w-[200px] py-[5px] absolute z-[16] text-left bg-[#fff]
          block ${open ? "opacity-100 visible" : "opacity-0 invisible"}
          ${dropdownTopClass} ${dropdownAlignClass}
          border-[1px] border-solid border-[#eee] rounded-[5px]
          before:content-[''] before:absolute before:top-[-25px] before:left-0 before:right-0 before:h-[25px] before:bg-transparent`}
                >
                    <li>
                        <Link
                            className="dropdown-item py-[10px] px-[15px] block w-full font-medium text-[13px]
              text-gray-800 hover:bg-transparent hover:text-[#9F2225]"
                            to="/user-profile"
                        >
                            Profile
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="dropdown-item py-[10px] px-[15px] block w-full font-medium text-[13px]
              text-gray-800 hover:bg-transparent hover:text-[#9F2225]"
                            to="/user-logout"
                        >
                            Logout
                        </Link>
                    </li>
                </ul>
            ) : (
                <ul
                    className={`gi-dropdown-menu min-w-[200px] py-[5px] absolute z-[16] text-left bg-[#fff]
          block ${open ? "opacity-100 visible" : "opacity-0 invisible"}
          ${dropdownTopClass} ${dropdownAlignClass}
          border-[1px] border-solid border-[#eee] rounded-[5px]
          before:content-[''] before:absolute before:top-[-25px] before:left-0 before:right-0 before:h-[25px] before:bg-transparent`}
                >
                    <li>
                        <Link
                            className="dropdown-item py-[10px] px-[15px] block w-full font-medium text-[13px]
              text-gray-800 hover:bg-transparent hover:text-[#9F2225]"
                            to="/user-login"
                        >
                            Login
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="dropdown-item py-[10px] px-[15px] block w-full font-medium text-[13px]
              text-gray-800 hover:bg-transparent hover:text-[#9F2225]"
                            to="/user-register"
                        >
                            Register
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="dropdown-item py-[10px] px-[15px] block w-full font-medium text-[13px]
              text-gray-800 hover:bg-transparent hover:text-[#9F2225]"
                            to="/astrologer-login"
                        >
                            Astrologer/Pandit Login
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="dropdown-item py-[10px] px-[15px] block w-full font-medium text-[13px]
              text-gray-800 hover:bg-transparent hover:text-[#9F2225]"
                            to="/astrologer-register"
                        >
                            Astrologer/Pandit Registration
                        </Link>
                    </li>
                </ul>
            )}
        </div>
    );
};

export default AccountDropdown;
